"use strict";

var formValidation = require("base/components/formValidation");
var createErrorNotification = require("base/components/errorNotification");
var scrollAnimate = require("base/components/scrollAnimate");
var recaptchaCheck = require("../components/recaptchaCheck");
var showAlert = require("../components/showAlert");
var customerHelpers = require("../checkout/customer");
var inputmask = require("inputmask").default;
var drawer = require("../components/drawer");
var urlUtils = require("storefront/components/urlUtils");
var debounce = require("lodash/debounce");
const formHelpers = require("base/checkout/formErrors");
var redirectUrl = "";

function attachNavOnResetPasswordDrawerEvent(email) {
    $("a.open-reset-password").click(function (e) {
        e.preventDefault();
        $("form#reset-password-form input#reset-password-email").val(email);
        drawer.openDrawer(".js-reset-password-drawer");
    });
}

function clearResetForm() {
    $(".reset-response").remove();
    $(".reset-password-title").show();
    $(".request-password-body").children(".form-group").show();
    $("#reset-password-email").val("");
    $("#reset-password-email").removeClass("is-invalid");
    $("#submit-reset-email")
        .text("Send")
        .removeClass("js-drawer-open")
        .removeAttr("data-target", ".js-login-drawer")
        .attr("type", "submit");
}

/**
* Resets the existing customer form to its initial state by toggling visibility classes
* and clearing the customer ID list. Shows the first step form, hides the first step list,
* and empties the list of customer IDs in the UI.
*
* @returns {void}
*/
function resetExistingCustomerForm() {
    var $firstStepForm = $(".js-first-step-form-wrapper");
    var $firstStepList = $(".js-first-step-list-wrapper");
    var customerForm = $("#existing-customer");
    var checkAction = customerForm.data("check-action");

    $firstStepForm.removeClass("d-none");
    $firstStepList.addClass("d-none");
    customerForm.attr("action", checkAction);
    $(".js-id-list-wrapper").empty();
    $(".js-proceed-btn").attr("disabled", true);
}

function clearLoginForm() {
    let loginForms = $(".registered-form");

    loginForms.each(function (formIndex, form) {
        let inputs = $(form).find("input");

        inputs.each(function (inputIndex, input) {
            if ($(input).attr("type") === "checkbox" && $(input).attr("id") !== "add-to-email-list") {
                $(input).prop("checked", false);
            } else if ($(input).attr("type") !== "hidden") {
                $(input).val("");
                $(input).removeClass("is-invalid");
            }
        });
        $(".already-registered").addClass("d-none");
        $(".js-join-partially-enrolled").addClass("d-none");
        $(".helper-text-mobile").removeClass("d-none");
        $("#registration-form-phone").removeAttr("disabled");
        $(form).find(".alert").remove();
    });

    resetExistingCustomerForm();
}

/**
 * Appends the product ID of the product in the wishlist to the login and registration URLs.
 * @param {object} self - The clicked element.
 */
function appendWishlistProductIdToLoginUrls(self) {
    const $self = $(self);
    if ($self.attr("data-pid")) {
        const wishlistProductId = $self.attr("data-pid");
        $(".js-input-pid").val(wishlistProductId);
    }
}

function getWishlistProductId() {
    const $pid = $(".js-input-pid");
    if ($pid && $pid.length > 0) {
        return $pid.val();
    }
}

function toggleRequiredMobilePhone() {
    var $registerMobilePhone = $(".js-register-mobile-phone");
    if (!$registerMobilePhone.data("phone-mandatory")) {
        if (!$registerMobilePhone.hasClass("required")) {
            $registerMobilePhone.addClass("required");
            $registerMobilePhone.find("input").attr("required", true);
        } else {
            $registerMobilePhone.removeClass("required");
            $registerMobilePhone.find("input").attr("required", false);
        }
    }
}

var debounceRequiredChange = debounce(toggleRequiredMobilePhone, 100);

/**
 * Toggles pre-enroll fields based on a condition
 * @param {boolean} condition - the condition to check
 * @param {Object} data - the data object containing resettingCustomerEmail and primaryWmeId
 * @returns {void}
 */
function togglePreEnrollFields(condition, data) {
    if (condition === true) {
        $(".js-form-email").val(data.resettingCustomerEmail);
        $(".js-preroll-email").val(data.resettingCustomerEmail);
        $(".js-preroll-email").prop("disabled", true);
        $("#registration-form-phone").val(data.primaryWmeId);
        $("#registration-form-phone").prop("disabled", true);
        $(".js-join-partially-enrolled").removeClass("d-none");
        $(".helper-text-mobile").addClass("d-none");
    } else {
        $(".js-form-email").val(data.resettingCustomerEmail);
        $(".js-preroll-email").val("");
        $(".js-preroll-email").prop("disabled", false);
        $("#registration-form-phone").val("");
        $("#registration-form-phone").prop("disabled", false);
        $(".js-join-partially-enrolled").addClass("d-none");
        $(".helper-text-mobile").removeClass("d-none");
    }
}

/**
* Handles the visibility and form action for an existing customer login form.
* Updates the form's action attribute based on its data attribute and toggles
* the visibility of account join steps by adding or removing the 'd-none' class.
*
* @returns {void}
*/
function handleExistingCustomerFormVisibility($this) {
    var $customerForm = $this.parents("form");
    var submitAction = $customerForm.data("submit-action");

    $customerForm.attr("action", submitAction);
    $customerForm.find(".form-control.is-invalid").removeClass("is-invalid");

    $(".js-account-join-first").addClass("d-none");
    $(".js-account-join-second").removeClass("d-none");
}

/**
* Fills a form element with a given value and toggles the visibility of a lock icon based on the value.
* If a value is provided, sets the value of the element, enables it, and shows the lock icon.
* If no value is provided, disables the element and hides the lock icon.
*
* @param {string} value - The value to set in the form element.
* @param {string} selector - The jQuery selector for the target form element.
*/
function fillFormElement(value, selector) {
    var $element = $(selector);
    if (value) {
        $element.val(value);
        $element.closest(".form-group").find(".icon-lock").removeClass("d-none");
    } else {
        $element.removeClass("pseudo-disabled");
        $element.val("");
        $element.closest(".form-group").find(".icon-lock").addClass("d-none");
    }
}

/**
* Populates the existing customer registration form fields with the provided customer's data.
* Clears the password and email fields to ensure sensitive information is not pre-filled.
*
* @param {Object} selectedCustomer - The customer object containing user details.
* @param {string} selectedCustomer.firstName - The customer's first name.
* @param {string} selectedCustomer.lastName - The customer's last name.
* @param {string} selectedCustomer.wmeId - The customer's phone number or WME ID.
* @param {string} selectedCustomer.MobileEnrolledPhoneNumber - The customer's enrolled mobile phone number.
*/
function populateExistingCustomerForm(selectedCustomer) {
    fillFormElement(selectedCustomer.firstName || "", "#ea-registration-form-fname");
    fillFormElement(selectedCustomer.lastName || "", "#ea-registration-form-lname");
    fillFormElement(selectedCustomer.email || "", "#ea-registration-form-email");
    fillFormElement(selectedCustomer.wmeId || "", "#ea-registration-form-phone");
    fillFormElement(selectedCustomer.MobileEnrolledPhoneNumber || "", "#ea-phoneMobile");

    $("#ea-checkout-registration-form-password").val("");
}

/**
* Populates the first step list in the login flow with customer radio options.
* Clears any existing content in the element with class 'js-id-list-wrapper' and appends a list of radio buttons,
* each representing a masked customer ID from the provided data.
*
* @param {Object} data - The data object containing customer information.
* @param {Array<Object>} data.wmCustomers - Array of customer objects to display.
* @param {string} data.wmCustomers[].masketWmeId - The masked WME ID to display for each customer.
* @param {string} data.wmCustomers[].wmeId - The actual WME ID used as the value for each radio input.
*/
function populateFirstStepList(data) {
    $(".js-id-list-wrapper").empty(); // limpa conteúdo antigo

    data.wmCustomers.forEach((customer, index) => {
        var maskedId = customer.masketWmeId;
        var wmeId = customer.wmeId;

        var html = `
          <div class="pseudo-radio">
            <div class="custom-radio">
              <div class="custom-radio-wrapper">
                <input
                  class="form-check-input"
                  type="radio"
                  name="existingCustomerId"
                  id="number-${index}"
                  value="${wmeId}" />
                <label class="d-flex form-check-label" for="number-${index}">
                  <span class="d-flex align-items-center text text-base bold text-color-t300 margin-16-left">
                    ${maskedId}
                  </span>
                </label>
              </div>
            </div>
          </div>`;

        $(".js-id-list-wrapper").append(html);
    });
}

module.exports = {
    initialize: function () {
        $(".js-icon-eye").on("click", function () {
            if ($(this).siblings("input").attr("type") == "password") {
                $(this).siblings("input").attr("type", "text");
            } else {
                $(this).siblings("input").attr("type", "password");
            }
        });

        return;
    },
    login: function () {
        $("form.login").submit(function (e) {
            var form = $(this);
            var wishlistProductId = getWishlistProductId();
            var companyTag = window.sweepstakeOnLogin ? window.sweepstakeOnLogin.companyTag : null;
            var sweepstakeEntry = window.cheetahSweepstakeOnLogin ? window.cheetahSweepstakeOnLogin.sweepstakeEntry : null;
            var pageId = $(".js-page-id").length > 0 ? $(".js-page-id").val() : null;

            e.preventDefault();
            form.spinner().start();

            if ($(".registered-form.login .alert").length) {
                $(".registered-form.login .alert").addClass("d-none");
            }

            let captchaAction = "Login";
            recaptchaCheck.getRecaptchaToken(function (token) {
                let formData = form.serializeArray();
                formData =  [
                    ...formData,
                    { "name": "wishlistProductId", "value" : wishlistProductId },
                    { "name": "gRecaptchaResponse", "value": token},
                    { "name": "captchaAction", "value": captchaAction}
                ];

                if (companyTag !== null) {
                    formData.push({ "name": "companyTag", "value": companyTag });
                    delete window.sweepstakeOnLogin;
                }

                if (sweepstakeEntry !== null) {
                    formData.push({ "name": "sweepstakeEntry", "value": sweepstakeEntry });
                    formData.push({ "name": "sweepsStakeSignup", "value": window.cheetahSweepstakeOnLogin.sweepsStakeSignup });
                    delete window.cheetahSweepstakeOnLogin;
                }

                if (pageId !== null) {
                    formData.push({ "name": "pageId", "value": pageId });
                }

                var url = form.attr("action");
                $("form.login").trigger("login:submit", e);
                $.ajax({
                    url: url,
                    type: "post",
                    dataType: "json",
                    data: formData,
                    success: function (data) {
                        if (!data.success) {
                            form.spinner().stop();
                            formValidation(form, data);
                            attachNavOnResetPasswordDrawerEvent(data.email);
                            $("form.login").trigger("login:error", data);

                            window.dispatchEvent(new CustomEvent("loginFailed", {
                                detail: {
                                    fields: data.aFieldErrors ? data.aFieldErrors : data.error,
                                }
                            }));
                        } else {
                            $("form.login").trigger("login:success", data);

                            if (data.showWishListsModal) {
                                const newurl = urlUtils.updateURLWithParam(window.location.href, "showWishListsModal", data.showWishListsModal);
                                window.location.href = newurl;

                                return;
                            } else {
                                redirectUrl = data.redirectUrl;
                            }

                            window.dispatchEvent(new CustomEvent("loginSuccess", {
                                detail: {
                                    ...data.aLogin,
                                }
                            }));

                            if (redirectUrl.length > 0) {
                                location.href = redirectUrl;
                            } else {
                                if ($(".page").data("refresh")) {
                                    location.reload();
                                } else {
                                    location.href = data.redirectUrl;
                                }
                            }

                            scrollAnimate();
                        }
                    },
                    error: function (data) {
                        if (data.responseJSON.redirectUrl) {
                            window.location.href = data.responseJSON.redirectUrl;
                        } else {
                            $("form.login").trigger("login:error", data);
                            form.spinner().stop();
                        }
                    }
                });
                return false;
            }, captchaAction);
        });
    },

    register: function () {
        $("form.registration").submit(function (e) {
            var form = $(this);
            var wishlistProductId = getWishlistProductId();
            var companyTag = window.sweepstakeOnLogin ? window.sweepstakeOnLogin.companyTag : null;
            var sweepstakeEntry = window.cheetahSweepstakeOnLogin ? window.cheetahSweepstakeOnLogin.sweepstakeEntry : null;
            var pageId = $(".js-page-id").length > 0 ? $(".js-page-id").val() : null;

            e.preventDefault();

            var $existingAccountNextStepButton = $(".js-existing-account-continue-step");

            if ($existingAccountNextStepButton.length > 0 && $existingAccountNextStepButton.is(":visible")) {
                $existingAccountNextStepButton.trigger("click");
                return;
            }

            form.spinner().start();
            let captchaAction = "Registration2";
            recaptchaCheck.getRecaptchaToken(function (token) {
                let formData = form.serializeArray();

                var phoneFormData = formData.find(function (element) {
                    return element.name === "dwfrm_profile_customer_phone";
                });

                if (phoneFormData && phoneFormData.value) {
                    phoneFormData.value = phoneFormData.value.replace(/[^0-9]/g, "");
                }

                if (!phoneFormData) {
                    formData.push({ "name": "dwfrm_profile_customer_phone", "value": "0000000000" });
                }

                formData =  [
                    ...formData,
                    { "name": "wishlistProductId", "value" : wishlistProductId },
                    { "name": "gRecaptchaResponse", "value": token},
                    { "name": "captchaAction", "value": captchaAction}
                ];

                if (companyTag !== null) {
                    formData.push({ "name": "companyTag", "value": companyTag });
                    delete window.sweepstakeOnLogin;
                }

                if (sweepstakeEntry !== null) {
                    formData.push({ "name": "notRedirectToMyAccount", "value": true });
                    formData.push({ "name": "sweepstakeEntry", "value": sweepstakeEntry });
                    formData.push({ "name": "sweepsStakeSignup", "value": window.cheetahSweepstakeOnLogin.sweepsStakeSignup });
                    delete window.cheetahSweepstakeOnLogin;
                }

                if (pageId !== null) {
                    formData.push({ "name": "pageId", "value": pageId });
                }

                const active = $(".login-form-nav [aria-selected='true']").attr("aria-controls");
                if (form.attr(`data-${active}-url`)) {
                    const setAction = form.attr(`data-${active}-url`);
                    form.attr("action", setAction);
                }
                var url = form.attr("action");
                $("form.registration").trigger("login:register", e);
                $.ajax({
                    url: url,
                    type: "post",
                    dataType: "json",
                    data: formData,
                    /**
                     * Success callback function for an AJAX request
                     * @param {Object} data - The response data from the AJAX request
                     * @returns {void}
                     */
                    success: function (data) {
                        var isExistingCustomerForm = form.attr("id") === "existing-customer";

                        if (!data.success && !data.isPartialEnrollee) {
                            if (data.memberIdInUse) {
                                const $errorWrapper = $(".js-join-error-alert");
                                const $errorMsg = $errorWrapper.find(".alert");
                                if ($errorMsg.length > 0) {
                                    $errorMsg.remove();
                                }
                                createErrorNotification($(".js-join-error-alert"), data.parsedHtmlError);
                                customerHelpers.methods.initLoginTabEvents();
                                form.spinner().stop();
                                return;
                            }
                            $("form.registration").trigger("login:register:error", data);
                            formValidation(form, data);
                            customerHelpers.methods.initLoginTabEvents();

                            if (isExistingCustomerForm) {
                                window.dispatchEvent(new CustomEvent("completeProfileFailed", {
                                    detail: {
                                        fields: data.aFieldErrors || [],
                                        formName: "complete profile",
                                        type: "form error"
                                    }
                                }));
                            } else {
                                window.dispatchEvent(new CustomEvent("joinFailed", {
                                    detail: {
                                        fields: data.aFieldErrors || [],
                                        formName: "join",
                                        type: "form error"
                                    }
                                }));
                            }

                            form.spinner().stop();
                        } else {
                            window.dispatchEvent(new CustomEvent("joinSuccess", {
                                detail: {
                                    ...data.aRegister,
                                    signupFromSms: isExistingCustomerForm
                                }
                            }));

                            if (data.showWishListsModal) {
                                const newurl = urlUtils.updateURLWithParam(window.location.href, "showWishListsModal", data.showWishListsModal);
                                window.location.href = newurl;

                                return;
                            } else {
                                redirectUrl = data.redirectUrl;
                            }

                            $("form.registration").trigger("login:register:success", data);

                            if (redirectUrl && redirectUrl.length > 0) {
                                location.href = redirectUrl;
                            } else {
                                if ($(".page").data("refresh")) {
                                    location.reload();
                                } else {
                                    location.href = data.redirectUrl;
                                }
                            }
                        }
                    },
                    error: function (err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else {
                            const $errorWrapper = $(".js-join-error-alert");
                            const $errorMsg = $errorWrapper.find(".alert");
                            if ($errorMsg.length > 0) {
                                $errorMsg.remove();
                            }
                            createErrorNotification($errorWrapper, err.responseJSON.errorMessage);
                        }

                        form.spinner().stop();
                    }
                });
                return false;
            }, captchaAction);
        });
    },

    resetPassword: function () {
        $(".reset-password-form").submit(function (e) {
            e.preventDefault();
            let form = $(this);
            let url = form.attr("action");
            $(".reset-password-form").trigger("login:register", e);
            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                data: form.serialize(),
                /**
                 * Handles the success response from an AJAX request
                 * @param {Object} data - The response data object
                 */
                success: function (data) {
                    if (!data.success) {
                        formValidation(form, data);
                    } else if (data.isPartialEnrollee) {
                        if ($(".checkout-page") && $(".checkout-page").length > 0) {
                            $(".js-reset-drawer-close").trigger("click");
                            $(".js-register-tab").trigger("click");
                            $("#registration-form-email").val(data.resettingCustomerEmail);
                            $(".js-continue-step").trigger("click");
                        } else {
                            let customerForm = $("#guest-customer");
                            let submitAction = customerForm.data("submit-action");
                            $(".js-login-drawer-open[data-option=join]").trigger("click");
                            $(".js-account-join-first").addClass("d-none");
                            $(".js-account-join-second").removeClass("d-none");
                            customerForm.attr("action", submitAction);
                        }
                        togglePreEnrollFields(true, data);
                        window.isPartialEnrolleeFirst = true;
                    } else if (data.emailNotExist) {
                        if ($(".checkout-page") && $(".checkout-page").length > 0) {
                            $(".js-reset-drawer-close").trigger("click");
                            $(".js-register-tab").trigger("click");
                        } else {
                            $(".reset-password-form").addClass("d-none");
                            $(".js-email-not-exist-container").removeClass("d-none");

                            $(".js-email-not-exist-btn").on("click", function () {
                                $(".js-login-drawer-open[data-option=join]").trigger("click");
                            });
                        }

                        togglePreEnrollFields(false, data);
                    } else {
                        $(".reset-password-title").hide();
                        $(".request-password-body").children(".form-group").hide();
                        $(".js-reset-drawer-title").text(data.receivedMsgHeading);
                        $(".request-password-body").append("<span class='reset-response text text-base medium text-color-t200'>" + data.receivedMsgBody + "</span>");

                        if (!data.mobile) {
                            $("#submit-reset-email")
                                .text(data.buttonText)
                                .addClass("js-drawer-open")
                                .attr("data-target", ".js-login-drawer")
                                .attr("type", "button");
                        } else {
                            $(".send-email-btn").empty()
                                .html("<a href='"
                                    + data.returnUrl
                                    + "' class='btn btn-primary btn-block'>"
                                    + data.buttonText + "</a>"
                                );
                        }

                        window.dispatchEvent(new CustomEvent("completePasswordReset", {}));
                    }
                }
            });
            return false;
        });
    },

    sendPasswordlessForm: function () {
        $(".passwordless-form").submit(function (e) {
            e.preventDefault();
            let form = $(this);
            let url = form.attr("action");
            $(".passwordless-form").trigger("login:register", e);
            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                data: form.serialize(),
                success: function (data) {
                    if (!data.success) {
                        if (data.errorCode ==="account.not.found") {
                            drawer.openDrawer(".js-confirmation-no-account-drawer");
                        } else {
                            formValidation(form, data);
                            attachNavOnResetPasswordDrawerEvent(data.email);
                        }
                    } else {
                        drawer.openDrawer(".js-confirmation-passwordless-drawer");
                    }
                }
            });
            return false;
        });
    },

    joinContinueStep: function () {
        $(".js-account-continue-step").on("click", function (e) {
            e.preventDefault();
            let customerForm = $(this).parents("form");

            // TODO: separate join steps forms and remove this workaround
            $("#guest-customer input").removeClass("is-invalid");

            let captchaAction = "Registration1";
            recaptchaCheck.getRecaptchaToken(function (token) {
                let defer = $.Deferred();
                let newFormData = customerForm.serializeArray();
                let submitAction = customerForm.data("submit-action");

                newFormData = [
                    ...newFormData,
                    { "name": "gRecaptchaResponse", "value": token },
                    { "name": "captchaAction", "value": captchaAction}
                ];

                $.ajax({
                    url: customerForm.attr("action"),
                    type: "post",
                    data: newFormData,
                    success: function (data) {
                        if (data.success === false || data.error === true) {
                            showAlert(data);
                        }

                        if (data.nextStep) {
                            $(".js-account-join-first").addClass("d-none");
                            $(".js-account-join-second").removeClass("d-none");
                            customerForm.attr("action", submitAction);

                            if (data.isPartialEnrollee) {
                                $(".js-join-partially-enrolled").removeClass("d-none");
                                $(".js-form-email").val(data.customerEmail);
                                $(".js-preroll-email").val(data.customerEmail);
                                $(".js-preroll-email").attr("disabled", "disabled");
                                $("#registration-form-phone").val(data.primaryWmeId);
                                $("#registration-form-phone").attr("disabled", "disabled");
                                $(".helper-text-mobile").addClass("d-none");
                            }
                        } else {
                            if (data.redirectUrl) {
                                window.location.href = data.redirectUrl;
                            } else {
                                customerHelpers.methods.customerFormResponse(defer, data);

                                if (data.isCustomerRegistered) {
                                    $(".already-registered").removeClass("d-none");
                                    $(".already-registered button").attr("disabled", false);
                                }

                                window.dispatchEvent(new CustomEvent("joinFailed", {
                                    detail: {
                                        fields: [{ ["dwfrm_profile_customer_email"]: data.fieldErrors[0].dwfrm_profile_customer_email }],
                                        formName: "join",
                                        type: "form error"
                                    }
                                }));
                            }
                        }
                        if (!data.isCustomerRegistered) {
                            $(".already-registered").addClass("d-none");
                            $(".already-registered button").attr("disabled", true);
                        }
                    },
                    error: function (err) {
                        if (err.responseJSON && err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        }
                        // Server error submitting form
                        defer.reject(err.responseJSON);
                    }
                });
            }, captchaAction);
        });
    },

    existingAccountContinueStep: function () {
        $(".js-existing-account-continue-step").on("click", function (e) {
            e.preventDefault();
            var $this = $(this);
            var customerForm = $this.parents("form");
            var $generalContainer = $this.closest(".login-page");

            // TODO: separate join steps forms and remove this workaround
            $("#guest-customer input").removeClass("is-invalid");

            var captchaAction = "Registration1";
            recaptchaCheck.getRecaptchaToken(function (token) {
                var defer = $.Deferred();
                var newFormData = customerForm.serializeArray();

                newFormData = [
                    ...newFormData,
                    { "name": "gRecaptchaResponse", "value": token },
                    { "name": "captchaAction", "value": captchaAction}
                ];

                $generalContainer.spinner().start();

                $.ajax({
                    url: customerForm.attr("action"),
                    type: "post",
                    data: newFormData,
                    success: function (data) {
                        if (data.success === false || data.error === true) {
                            showAlert(data);
                        }

                        var isMultipleNumbersFound = data.wmCustomers && data.wmCustomers.length > 1;

                        if (data.isPartialEnrollee && !data.isCustomerRegistered) {
                            if (isMultipleNumbersFound) {
                                var $firstStepForm = $(".js-first-step-form-wrapper");
                                var $firstStepList = $(".js-first-step-list-wrapper");

                                populateFirstStepList(data);

                                $firstStepForm.addClass("d-none");
                                $firstStepList.removeClass("d-none");

                                $(".js-customers-list-data").val(JSON.stringify(data.wmCustomers));
                            }

                            if (data.wmCustomers && data.wmCustomers.length === 1) {
                                populateExistingCustomerForm(data.wmCustomers[0]);
                                handleExistingCustomerFormVisibility($this);
                            }
                        } else {
                            if (data.fieldErrors && data.fieldErrors.length > 0) {
                                data.fieldErrors.forEach(function (error) {
                                    if (Object.keys(error).length) {
                                        formHelpers.loadFormErrors(".existing-account-form-wrapper .registered-form", error);
                                    }
                                });
                            }
                        }

                        var keyToExtract = "dwfrm_profile_customer_partialEnrollPhone";
                        var newArray = [];

                        $.each(data.fieldErrors, function (i, obj) {
                            // eslint-disable-next-line no-prototype-builtins
                            if (obj.hasOwnProperty(keyToExtract)) {
                                var extracted = {};
                                extracted[keyToExtract] = obj[keyToExtract];
                                newArray.push(extracted);
                            }
                        });

                        if (data.error === true) {
                            window.dispatchEvent(new CustomEvent("completeProfileFailed", {
                                detail: {
                                    fields: newArray || [],
                                    formName: "complete profile",
                                    type: "form error"
                                }
                            }));
                        } else {
                            window.dispatchEvent(new CustomEvent("completeProfilePhoneSubmit", {
                                detail: {
                                    fields: newArray ? newArray : data.error,
                                    multipleNumbersFound: isMultipleNumbersFound
                                }
                            }));
                        }

                        $generalContainer.spinner().stop();
                    },
                    error: function (err) {
                        $generalContainer.spinner().stop();

                        if (err.responseJSON && err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        }

                        // Server error submitting form
                        defer.reject(err.responseJSON);
                    }
                });
            }, captchaAction);
        });
    },

    /**
    * Attaches a click event handler to elements with the class '.js-proceed-btn' within the body.
    * When such an element is clicked, triggers the visibility handler for the existing customer form.
    * @function
    * @memberof login
    */
    handleProceedBtn: function () {
        $("body").on("click", ".js-proceed-btn", function () {
            handleExistingCustomerFormVisibility($(this));
        });
    },

    /**
    * Attaches a click event handler to elements with the class '.js-redirect-to-login' that closes the login drawer
    * and then reopens it after a short delay. This is typically used to ensure the login drawer is refreshed or reset
    * when a user attempts to access the login functionality from certain UI elements.
    *
    * @function
    * @returns {void}
    */
    redirectToLogin: function () {
        $("body").on("click", ".js-redirect-to-login", function () {
            $(".js-login-drawer-close").trigger("click");

            setTimeout(function () {
                $(".js-login-drawer-open[data-option=\"login\"]").trigger("click");
            }, 800);
        });
    },

    /**
    * Handles the selection of an existing customer account from a list and populates the registration form fields accordingly.
    * Attaches a change event listener to inputs named 'existingCustomerId', retrieves the selected customer data,
    * and updates the relevant form fields (first name, last name, phone, mobile number) with the selected customer's information.
    * Also clears the password field and enables the proceed button.
    *
    * @function
    */
    existingAccountListSelection: function () {
        $(document).on("change", "input[name='existingCustomerId']", function () {
            var selectedId = $(this).val();
            var customers = JSON.parse($(".js-customers-list-data").val());
            var selectedCustomer = customers.find(c => c.wmeId === selectedId);

            populateExistingCustomerForm(selectedCustomer);

            $(".js-proceed-btn").attr("disabled", false);
        });
    },

    // Handle sign-in redirect click event, pre-fill email input, and switch to login tab
    handleSignInRedirect: function () {
        $(".sign-in-redirect").on("click", function (event) {
            event.preventDefault();
            var enteredEmail = $("#registration-form-email").val();

            $("#login-form-email").val(enteredEmail);
            $(".js-register-tab").removeClass("active");
            $(".js-login-tab").addClass("active");
            $("#register").removeClass("active");
            $("#login").addClass("active");
        });
    },

    handleSignInRedirectSummary: function () {
        $(".sign-in-redirect-summary").on("click", function (e) {
            e.preventDefault();
            var enteredEmail = $("#confirmationEmal").val();

            $("#login-form-email").val(enteredEmail);
        });
    },

    changeMobileHelpText: function () {
        $("body").on("click", ".js-account-continue-step", function (e) {
            e.preventDefault();

            if ($("#loyalty-sign-up-first").is(":checked")) {
                $(".helper-text-telephone").removeClass("d-none");
                $(".helper-text-mobile").addClass("d-none");
                $(".js-phone-label").empty().append(" " + $(".wmr-id-lable").data("phone-lable"));
            } else {
                $(".helper-text-mobile").removeClass("d-none");
            }
        });
    },

    regexPostalCode: function () {
        $("#zipCode, #accountZipCode, #postalCode, #profileZipCode, #billingZipCode, .shipping-zip-code").on("input", function () {
            var zipCodeInput = $(this).val();
            // Remove all non-numeric characters
            zipCodeInput = zipCodeInput.replace(/[^0-9]/g, "");

            if (zipCodeInput.length > 5 && zipCodeInput.length < 10) {
                // Add a hyphen after the fifth digit
                zipCodeInput = zipCodeInput.replace(/(\d{5})(\d{1,4})/, "$1-$2");
            }
            // Set the zip code input value to the modified value
            $(this).val(zipCodeInput);
        });
    },

    inputPhoneMask: function () {
        inputmask({"mask": "(999) 999-9999"}).mask("#phone, #phoneMobile, .shippingPhoneNumber, #phoneNumber, #communications-phone-sms, #existingPhoneMobile, #ea-phoneMobile");
    },

    openResetPasswordModal: function () {
        $("body").on("click", ".js-reset-drawer-open", function (e) {
            e.preventDefault();

            var target = $(this).data("target");
            var checkoutEmailInput = $(".registered-form").find("#email").val();

            $("#reset-password-email").val(checkoutEmailInput);
            $(".reset-password-form").removeClass("d-none");
            $(".js-email-not-exist-container").addClass("d-none");

            drawer.openDrawer(target);
            window.dispatchEvent(new CustomEvent("startPasswordReset", {}));
        });
    },

    restrictInputToNumbers: function () {
        $(".rewards-input").on("input", function () {
            this.value = this.value.replace(/[^0-9]/g, "");
        });
    },

    closeResetPasswordModal: function () {
        $("body").on("click", ".js-reset-drawer-close", function (e) {
            e.preventDefault();
            let target = $(this).closest(".drawer");

            clearResetForm();
            drawer.closeDrawer(target);
        });
    },

    /**
     * Event handler for opening the login drawer
     * @param {Event} e - The click event
     * @returns {void}
     */
    /**
     * Event handler for opening the login drawer
     * @param {Event} e - The click event
     * @returns {void}
     */
    openLoginModal: function () {
        $("body").on("click", ".js-login-drawer-open", function (e) {
            e.preventDefault();

            let $this = $(this);
            let target = $(".js-login-drawer");
            let option = $this.data("option");
            let isTriggeredByPromo = $this.closest(".js-promo-wrapper").length > 0;
            let isTriggeredByRewards = $this.closest(".js-rewards-wrapper").length > 0;
            let eventLocation = isTriggeredByRewards ? "rewards banner" : isTriggeredByPromo ? "promo banner" : $this.data("location") || "inline";
            let locationId = "";

            if (isTriggeredByPromo || isTriggeredByRewards) {
                locationId = $this.data("location-id");
            }

            if ($this.parents(".checkout-page").length > 0) {
                return;
            }

            if ($(".js-is-authenticated").val() === "true") {
                redirectUrl = $this.data("action");
            }

            appendWishlistProductIdToLoginUrls(this);

            // if the user is registered then open the data-action url instead of the login drawer
            if ($("#js-a-page-customer").data("status") === "registered") {
                window.location.href = $this.data("action");
                return;
            }

            var $loginTab = $(".js-login-tab");
            var $registerTab = $(".js-register-tab");
            var $existingAccountTab = $(".js-existing-account-tab");

            if (!option || option === "login") {
                $loginTab.addClass("active");
                $registerTab.removeClass("active");
                $existingAccountTab.removeClass("active");
            } else if (option === "completeProfile") {
                $loginTab.removeClass("active");
                $registerTab.removeClass("active");
                $existingAccountTab.addClass("active");
            } else {
                $loginTab.removeClass("active");
                $registerTab.addClass("active");
                $existingAccountTab.removeClass("active");
            }

            var $tabs = $(".login-form-nav .nav-tabs");
            var $tabContent = $(".login-form-nav .tab-content");

            if (option === "completeProfile") {
                $tabs.addClass("d-none");
                $tabContent.removeClass("pdd-24-top");
            } else {
                $tabs.removeClass("d-none");
                $tabContent.addClass("pdd-24-top");
            }

            drawer.openDrawer(target);

            let customerForm = $(".js-account-continue-step").parents("form");
            let submitAction = customerForm.data("check-action");

            $(".js-account-join-first").removeClass("d-none");
            $(".js-account-join-second").addClass("d-none");
            customerForm.attr("action", submitAction);

            if (option === "completeProfile") {
                window.dispatchEvent(new CustomEvent("completeProfileDrawer", {
                    detail: {
                        type: "complete profile"
                    }
                }));
            } else {
                window.dispatchEvent(new CustomEvent("loginDrawerOpen", {
                    detail: {
                        locationId: locationId,
                        loginLocation: eventLocation,
                        type: option
                    }
                }));
            }

            // TODO: separate join steps forms and remove this workaround
            $("#guest-customer").on("keyup", function (ev) {
                var keyCode = ev.keyCode || ev.which;
                if (keyCode == 13) {
                    if ($("#registration-form-email").is(":focus")) {
                        $(".js-account-continue-step").click();
                    }
                }
            });
        });
    },

    /**
     * Detects SMS check event and triggers debounceRequiredChange function
     */
    detectSmsCheck: function () {
        $("body").on("click", ".js-register-sms-optin", debounceRequiredChange);
    },

    /**
    * Attaches an event listener to redirect partial enrollees to the registration process.
    * 
    * This function listens for click events on elements with the class `js-redirect-partial-enrollees`.
    * When triggered, it prevents the default action and fills in the guest customer form with the email
    * data attribute from the clicked element. It then simulates clicks on the registration tab and 
    * continue step button to guide the user through the registration process.
    * 
    * @listens click - on elements with the class `js-redirect-partial-enrollees`
    * @fires click - on elements with the class `js-register-tab` and `js-continue-step`
    */
    redirectPartialEnrollees: function () {
        $("body").on("click", ".js-redirect-partial-enrollees", function (e) {
            e.preventDefault();

            var $guestForm = $("#guest-customer");

            $guestForm.find(".js-form-email").val($(this).data("email"));
            $(".js-register-tab").trigger("click");
            $guestForm.find(".js-continue-step").trigger("click");
            $guestForm.find(".js-account-continue-step").trigger("click");
        });
    },

    closeLoginModal: function () {
        $("body").on("click", ".js-login-drawer-close", function (e) {
            e.preventDefault();
            let target = $(this).closest(".drawer");
            $(".helper-text-mobile, .helper-text-telephone").addClass("d-none");
            delete window.sweepstakeOnLogin;

            clearLoginForm();
            drawer.closeDrawer(target);
        });
    },

    initClearLoginErrors: customerHelpers.methods.initClearLoginErrors
};
